// src/app/App.jsx
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider, TooltipProvider } from '@app/providers';
import AppRouter from '@app/router/AppRouter';

/**
 * Корень приложения.
 * BackgroundLayout перенесен внутрь AppRouter, 
 * чтобы не влиять на технические страницы (виджеты OBS).
 */
function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRouter />
      </Router>
    </AuthProvider>
  );
}

export default App;
